import {Col, Row, Back} from "@bezlimit/bezlimit-ui";
import {useNavigate} from "react-router-dom";
import "./style.scss";
// components
import {Profile} from "../../../blocks/profile";
import {useEffect} from "react";

export default function ProfilePage() {
    const navigate = useNavigate();
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://lib.usedesk.ru/secure.usedesk.ru/widget_164504_42100.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            // @ts-ignore
            window.usedeskMessenger.toggle(false);
        };
    }, []);

    return (
        <Row justify="center" gutter={32}>
            <Back navigate={() => navigate("/")} />
            <Col lg={{span: 24}} xs={{span: 24}}>
                <Profile />
            </Col>
        </Row>
    );
}
